export default "__VITE_ASSET__CiOah31a__"